module.exports = __webpack_public_path__ + "static/media/user-avtar.bc560060.png";